import { v4 as uuidv4 } from "uuid";
import { updateField } from "vuex-map-fields";
import moment from "moment";
import useState from "./state";
import { resetState } from "../../../util/reset_store_state/reset_store_state";

const SET_INITIAL_CREATE_OR_EDIT_PAGE_DATA = (state, page) => {
  state.initialCreateOrEditPageData = page;
};
const SET_POLICY = (state, policy) => {
  state.policy = policy;
};

const SET_POLICY_ID = (state, id) => {
  state.policyId = id;
};

const SET_SAVED_AT = (state) => {
  state.savedAt = moment();
};
const SET_FORM = (state, form) => {
  state.form = form;
};

const LOADING = (state, loading) => {
  state.loading = loading;
};
const LOADING_PAGE = (state, bool) => {
  state.loadingPage = bool;
};

const SET_CUSTOMER_ID = (state, id) => {
  state.customerId = id;
};

const ADD_VIEW_GROUPS = (state, {
  viewGroups,
  brancheId,
}) => {
  const clone = { ...state.viewGroups };
  clone[brancheId] = viewGroups;
  state.viewGroups = clone;
};
const SET_ACTIVE_BRANCH_ID = (state, id) => {
  const clone = {
    ...state.form,
    branch_id: id,
  };
  state.form = clone;
};

const SET_NEW_VIEWS = (state, newViews) => {
  const clone = { ...state.views };
  const originalViews = state.form.view_group_id in state.views
    ? state.views[state.form.view_group_id] : {};
  clone[state.form.view_group_id] = { ...originalViews, ...newViews };
  state.views = clone;
};

const DELETE_VIEW = (state, uuid) => {
  const views = { ...state.form.views };
  const newViews = Object.values(views)
    .filter((view) => view.uuid !== uuid);
  state.form.views = newViews;
};

const SET_VIEW_OPTIONS = (state, viewOptions) => {
  state.viewOptions = {
    ...state.viewOptions,
    [state.form.view_group_id]: viewOptions,
  };
};

const SET_ACTIVE_VIEW_GROUP_ID = (state, id) => {
  state.activeViewGroupId = id;
};
const SET_IS_SINGLE_POLICY = (state, bool) => {
  state.isSinglePolicy = bool;
};

const SET_PACKAGE = (state, policy) => {
  state.package = policy;
};
const SET_PACKAGE_ID = (state, id) => {
  const clonedForm = { ...state.form };
  clonedForm.parent_id = id;
  state.form = clonedForm;
};

const SET_IS_PACKAGE = (state, bool) => {
  const clonedForm = { ...state.form };
  clonedForm.is_package = bool;
  state.form = clonedForm;
};
const SET_FORM_VIEW_FIELD = (state, {
  viewIndex,
  catalogId,
  field,
}) => {
  const clonedForm = { ...state.form };
  if (viewIndex >= clonedForm.views.length) return;
  const updatedView = clonedForm.views[viewIndex];
  if (!(catalogId in updatedView.inputs)) return;
  updatedView.inputs[catalogId] = field;

  clonedForm.views[viewIndex] = updatedView;
  state.form = clonedForm;
};
const SET_FORM_VIEW_FIELD_VALUE = (state, {
  catalogId,
  viewIndex,
  value,
}) => {
  const clonedForm = { ...state.form };
  if (viewIndex >= clonedForm.views.length) return;
  const updatedView = clonedForm.views[viewIndex];
  // When creating a new policy or adding a new coverage the inputs are not an array
  // This is a workaround to get access to the findIndex function
  if (updatedView.inputs.constructor !== Array) {
    updatedView.inputs = Object.entries(updatedView.inputs).map(([, input]) => input);
  }
  const inputIndex = updatedView.inputs.findIndex((input) => input.catalog_id === catalogId);
  if (inputIndex === -1) return;
  updatedView.inputs[inputIndex].attributes.value = value;
  clonedForm.views[viewIndex] = updatedView;
  state.form = clonedForm;
};
const SET_FORM_VIEWS = (state, views) => {
  state.form.views = views.map((view) => ({
    ...view,
    uuid: uuidv4(),
  }));
};
const PUSH_VIEW_TO_FORM = (state, view) => {
  const form = { ...state.form };
  // Add a unique identifier to the view object for front end looping.
  const newView = {
    ...view,
    uuid: uuidv4(),
  };
  form.views.push(newView);
  state.form = form;
};
const SET_FORM_VALUE = (state, {
  key,
  value,
}) => {
  state.form[key] = value;
};

const SET_FORM_VALUES_FROM_POLICY = (state) => {
  state.form = state.initialCreateOrEditPageData.form;
};
const SET_LOADING_RESPONSE = (state, value) => {
  state.loadingResponse = value;
};
const SET_POLICY_VIEW_ID = (state, ids) => {
  state.form = {
    ...state.form,
    policy_view_id: ids,
  };
};

const SET_VIEW_GROUP_ID = (state, id) => {
  state.form = {
    ...state.form,
    view_group_id: id,
  };
};

const SET_VIEWS = (state, views) => {
  state.views = {
    ...state.views,
    [state.form.view_group_id]: views,
  };
};

const LOADING_VIEWS = (state, value) => {
  state.loadingViews = value;
};
const SET_CORPORATION_ID = (state, id) => {
  const clonedForm = { ...state.form };
  clonedForm.corporation_id = id;
  state.form = clonedForm;
};

const SET_VIEW_GROUP_MODEL_BY_ID = (state, {
  id,
  model,
}) => {
  state.viewGroupModels = {
    ...state.viewGroupModels,
    [id]: model,
  };
};

const SET_CUSTOMER_FAMILY = (state, customerFamily) => {
  state.customerFamily = customerFamily;
};

const CLEAR_GROUPS = (state) => {
  state.form = {
    ...state.form,
    newPolicyGroup: {},
    policyGroup: {},
  };
};

const SET_SHOW_NOTE_DYN1 = (state, value) => {
  state.show_note_dyn1 = Boolean(value === "1");
};

export default {
  SET_FORM_VIEWS,
  SET_FORM_VIEW_FIELD,
  SET_FORM_VIEW_FIELD_VALUE,
  CLEAR_GROUPS,
  SET_VIEW_GROUP_MODEL_BY_ID,
  SET_CORPORATION_ID,
  SET_VIEWS,
  PUSH_VIEW_TO_FORM,
  SET_POLICY,
  SET_POLICY_ID,
  SET_VIEW_GROUP_ID,
  SET_POLICY_VIEW_ID,
  SET_FORM_VALUE,
  SET_LOADING_RESPONSE,
  SET_FORM,
  SET_PACKAGE_ID,
  SET_CUSTOMER_ID,
  ADD_VIEW_GROUPS,
  LOADING,
  LOADING_PAGE,
  SET_NEW_VIEWS,
  SET_VIEW_OPTIONS,
  SET_IS_SINGLE_POLICY,
  SET_PACKAGE,
  SET_ACTIVE_VIEW_GROUP_ID,
  SET_SAVED_AT,
  SET_ACTIVE_BRANCH_ID,
  DELETE_VIEW,
  SET_FORM_VALUES_FROM_POLICY,
  SET_INITIAL_CREATE_OR_EDIT_PAGE_DATA,
  SET_IS_PACKAGE,
  LOADING_VIEWS,
  SET_CUSTOMER_FAMILY,
  SET_SHOW_NOTE_DYN1,
  resetState: resetState(useState),
  updateField,
};
